/* ============================================================
   Ruleta de descuentos (spin the wheel)

   Bloqueo de "un giro por visitante" en tres capas:
     1. localStorage  -> sobrevive recargas y cierres de pestana
     2. cookie        -> respaldo si se limpia el localStorage
     3. atributo del carrito (/cart/update.js) -> vive en la sesion
        de carrito de Shopify y ademas deja el codigo pegado a la
        orden, para poder medir cuanto vendio la ruleta

   Limite conocido: una ventana de incognito evade las tres, porque
   un tema es solo frontend y no hay servidor a quien preguntarle si
   este visitante ya giro. La proteccion real vive en la config del
   codigo de descuento en Shopify (limite de usos, vigencia, minimo
   de compra y no combinable).
   ============================================================ */

(function () {
  'use strict';

  var PLAYED_KEY = 'psw:played:v1';
  var PLAYED_COOKIE = 'psw_played';
  var DISMISS_COOKIE = 'psw_dismissed';
  var CART_ATTR = '_ruleta';

  function readCookie(name) {
    return document.cookie.split('; ').some(function (c) {
      return c.indexOf(name + '=') === 0;
    });
  }

  function writeCookie(name, days) {
    var maxAge = Math.max(1, days) * 86400;
    document.cookie = name + '=1; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function lsGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function lsSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* Modo privado o storage lleno: seguimos con cookie y carrito. */
    }
  }

  /* Elige un segmento respetando los pesos configurados.
     Peso 0 o negativo = nunca sale. Si todos son 0, reparte parejo. */
  function pickWeighted(segments) {
    var total = 0;
    var i;
    for (i = 0; i < segments.length; i++) {
      total += Math.max(0, Number(segments[i].weight) || 0);
    }
    if (total <= 0) {
      return Math.floor(Math.random() * segments.length);
    }
    var r = Math.random() * total;
    for (i = 0; i < segments.length; i++) {
      r -= Math.max(0, Number(segments[i].weight) || 0);
      if (r <= 0) {
        return i;
      }
    }
    return segments.length - 1;
  }

  /* Resuelve con `fallback` si la promesa tarda mas de `ms`. En movil una
     peticion puede quedarse colgada indefinidamente cuando la senal se cae,
     y no queremos que eso deje al visitante sin ruleta. */
  function withTimeout(promise, ms, fallback) {
    return Promise.race([
      promise,
      new Promise(function (resolve) {
        window.setTimeout(function () {
          resolve(fallback);
        }, ms);
      })
    ]);
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(ta);
      ok ? resolve() : reject();
    });
  }

  function Wheel(root) {
    this.root = root;
    this.designMode = !!(window.Shopify && window.Shopify.designMode);

    var configEl = root.querySelector('[data-psw-config]');
    if (!configEl) {
      return;
    }
    try {
      this.config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }
    if (!this.config.segments || !this.config.segments.length) {
      return;
    }

    this.dialog = root.querySelector('[data-psw-dialog]');
    this.backdrop = root.querySelector('[data-psw-backdrop]');
    this.wheelEl = root.querySelector('[data-psw-wheel]');
    this.spinBtn = root.querySelector('[data-psw-spin]');
    this.codeEl = root.querySelector('[data-psw-code]');
    this.copyBtn = root.querySelector('[data-psw-copy]');
    this.resultHeading = root.querySelector('[data-psw-result-heading]');
    this.resultText = root.querySelector('[data-psw-result-text]');
    this.codeRow = root.querySelector('[data-psw-code-row]');
    this.cta = root.querySelector('[data-psw-cta]');
    this.form = root.querySelector('form.psw__form');
    this.tab = root.querySelector('[data-psw-tab]');

    if (!this.dialog || !this.wheelEl || !this.spinBtn) {
      return;
    }

    this.hasNativeDialog = typeof this.dialog.showModal === 'function';
    if (!this.hasNativeDialog) {
      this.dialog.setAttribute('data-fallback', '');
    }

    this.spun = false;
    this.bind();
    this.maybeSchedule();
  }

  Wheel.prototype.bind = function () {
    var self = this;

    /* Un solo camino para girar, sin depender del envio nativo del
       formulario. El boton es type="button", asi que ni un error de JS ni
       una app que escuche submits puede provocar una recarga. */
    function attempt() {
      if (self.form) {
        if (typeof self.form.checkValidity === 'function' && !self.form.checkValidity()) {
          if (typeof self.form.reportValidity === 'function') {
            self.form.reportValidity();
          }
          return;
        }
        self.submitLead();
      }
      self.spin();
    }

    this.spinBtn.addEventListener('click', function (e) {
      e.preventDefault();
      attempt();
    });

    if (this.form) {
      /* Respaldo para el Enter dentro de los campos: algunos navegadores
         hacen envio implicito aunque no haya boton de tipo submit. */
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        attempt();
      });
    }

    if (this.tab) {
      this.tab.addEventListener('click', function () {
        self.openManual();
      });
    }

    Array.prototype.forEach.call(
      this.root.querySelectorAll('[data-psw-close]'),
      function (el) {
        el.addEventListener('click', function () {
          self.close(true);
        });
      }
    );

    if (this.copyBtn) {
      this.copyBtn.addEventListener('click', function () {
        var code = self.codeEl ? self.codeEl.value : '';
        if (!code) {
          return;
        }
        copyToClipboard(code)
          .then(function () {
            self.copyBtn.classList.add('is-copied');
            self.copyBtn.textContent = self.config.text.copied;
          })
          .catch(function () {
            if (self.codeEl) {
              self.codeEl.select();
            }
          });
      });
    }

    if (this.hasNativeDialog) {
      this.dialog.addEventListener('cancel', function () {
        self.markDismissed();
      });
      this.dialog.addEventListener('close', function () {
        self.root.classList.remove('is-open');
      });
    } else {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.dialog.classList.contains('is-open')) {
          self.close(true);
        }
      });
      if (this.backdrop) {
        this.backdrop.addEventListener('click', function () {
          self.close(true);
        });
      }
    }
  };

  /* Capas 1 y 2: baratas, sin red. Se consultan siempre primero. */
  Wheel.prototype.playedLocally = function () {
    return !!lsGet(PLAYED_KEY) || readCookie(PLAYED_COOKIE);
  };

  /* Capa 3: el carrito de Shopify. Solo se consulta si las dos
     anteriores estan limpias, para no gastar una peticion de mas. */
  Wheel.prototype.playedInCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        return !!(cart && cart.attributes && cart.attributes[CART_ATTR]);
      })
      .catch(function () {
        return false;
      });
  };

  Wheel.prototype.maybeSchedule = function () {
    var self = this;

    /* En el personalizador siempre se muestra, para poder disenarla.
       ?ruleta=test hace lo mismo en la tienda: salta el bloqueo para poder
       probar el flujo completo sin limpiar cookies ni localStorage. */
    if (this.designMode || /[?&]ruleta=test/.test(window.location.search)) {
      this.open();
      return;
    }

    if (this.playedLocally() || readCookie(DISMISS_COOKIE)) {
      return;
    }

    /* El temporizador arranca YA y la consulta al carrito corre en paralelo.
       Antes habia que esperar la respuesta de /cart.js para recien empezar a
       contar los segundos, asi que en conexiones lentas (lo normal en movil)
       la ruleta salia tarde, y si la peticion se colgaba no salia nunca. */
    this.cartCheck = withTimeout(this.playedInCart(), 3000, false);
    this.arm();
  };

  Wheel.prototype.arm = function () {
    var self = this;
    var cfg = this.config.trigger;
    var fired = false;

    function fire() {
      if (fired) {
        return;
      }
      fired = true;
      var check = self.cartCheck || Promise.resolve(false);
      check.then(function (played) {
        if (!played) {
          self.open();
        }
      });
    }

    if (cfg.type === 'now') {
      /* Sin espera. Las marcas locales (localStorage y cookie) ya se
         consultaron de forma sincrona antes de llegar aqui; la del carrito
         sigue corriendo y, si contradice, cierra el dialogo enseguida. */
      self.open();
      fired = true;
      if (self.cartCheck) {
        self.cartCheck.then(function (played) {
          if (played && !self.spun) {
            self.close(false);
          }
        });
      }
      return;
    }

    if (cfg.type === 'exit') {
      var onLeave = function (e) {
        if (e.clientY <= 0) {
          document.removeEventListener('mouseout', onLeave);
          fire();
        }
      };
      document.addEventListener('mouseout', onLeave);
      /* En movil no existe el exit intent: respaldo por tiempo. */
      window.setTimeout(fire, Math.max(cfg.delay, 12) * 1000);
      return;
    }

    if (cfg.type === 'scroll') {
      var onScroll = function () {
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
        if (pct >= cfg.scroll) {
          window.removeEventListener('scroll', onScroll);
          fire();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      return;
    }

    window.setTimeout(fire, Math.max(0, cfg.delay) * 1000);
  };

  Wheel.prototype.open = function () {
    if (this.hasNativeDialog) {
      if (!this.dialog.open) {
        this.dialog.showModal();
      }
    } else {
      this.dialog.classList.add('is-open');
      if (this.backdrop) {
        this.backdrop.classList.add('is-open');
      }
      this.spinBtn.focus();
    }
    this.root.classList.add('is-open');
  };

  /* Resultado guardado del giro anterior, si lo hay. */
  Wheel.prototype.savedResult = function () {
    try {
      return JSON.parse(lsGet(PLAYED_KEY) || 'null');
    } catch (e) {
      return null;
    }
  };

  /* Apertura desde la pestana flotante. A quien ya giro no se le deja girar
     de nuevo: se le muestra el codigo que se guardo, que es justo lo que
     suele venir a buscar. */
  Wheel.prototype.openManual = function () {
    var saved = this.savedResult();
    if (saved && !this.spun) {
      this.spun = true;
      this.spinBtn.disabled = true;
      this.showResult({
        label: saved.label || '',
        code: saved.code || '',
        losing: !saved.code
      }, true);
    }
    this.open();
  };

  Wheel.prototype.close = function (dismissed) {
    if (dismissed) {
      this.markDismissed();
    }
    if (this.hasNativeDialog) {
      if (this.dialog.open) {
        this.dialog.close();
      }
    } else {
      this.dialog.classList.remove('is-open');
      if (this.backdrop) {
        this.backdrop.classList.remove('is-open');
      }
    }
    this.root.classList.remove('is-open');
  };

  Wheel.prototype.markDismissed = function () {
    if (this.designMode || this.spun) {
      return;
    }
    writeCookie(DISMISS_COOKIE, this.config.dismissDays);
  };

  /* Se marca el giro como consumido ANTES de animar. Si se marcara al
     terminar, bastaria con recargar a mitad de la animacion para
     recuperar el intento. */
  Wheel.prototype.markPlayed = function (segment) {
    if (this.designMode) {
      return;
    }

    lsSet(
      PLAYED_KEY,
      JSON.stringify({
        t: Date.now(),
        code: segment.code || '',
        label: segment.label || ''
      })
    );
    writeCookie(PLAYED_COOKIE, this.config.cooldownDays);
  };

  /* La escritura al carrito va DESPUES de revelar el premio, no antes.
     Tocar /cart/update.js a mitad del giro hace que las apps de carrito
     (aqui hay un cajon de carrito instalado) re-rendericen o recarguen la
     pagina justo cuando el visitante espera su codigo. El bloqueo contra
     recargas no se debilita: localStorage y cookie ya se escribieron de
     forma sincrona al arrancar el giro. */
  Wheel.prototype.writeCartAttribute = function (segment) {
    if (this.designMode) {
      return;
    }
    var attrs = {};
    attrs[CART_ATTR] = segment.code || 'sin-premio';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {
      /* Si falla, quedan localStorage y cookie como respaldo. */
    });
  };

  /* Crea el registro en Shopify > Clientes usando el mismo endpoint que el
     newsletter del tema. Se dispara sin esperar respuesta para no retrasar el
     giro: el endpoint /contact no devuelve errores legibles por AJAX, asi que
     la validacion que importa ya corrio en el submit. */
  Wheel.prototype.submitLead = function () {
    if (!this.form || this.designMode) {
      return;
    }
    var action = (this.form.getAttribute('action') || '/contact').split('#')[0];
    fetch(action, {
      method: 'POST',
      body: new FormData(this.form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).catch(function () {
      /* Si falla la red el visitante igual recibe su codigo; se pierde el lead. */
    });
  };

  Wheel.prototype.spin = function () {
    if (this.spun) {
      return;
    }
    this.spun = true;
    this.spinBtn.disabled = true;

    var segments = this.config.segments;
    var index = pickWeighted(segments);
    var segment = segments[index];

    this.markPlayed(segment);

    var segAngle = 360 / segments.length;
    var spins = this.config.spins || 6;
    /* Ruido dentro del segmento para que no caiga siempre en el centro. */
    var jitter = (Math.random() - 0.5) * segAngle * 0.7;
    var target = 360 * spins - index * segAngle + jitter;

    var self = this;
    var settled = false;

    function finish() {
      if (settled) {
        return;
      }
      settled = true;
      self.showResult(segment);
    }

    this.wheelEl.addEventListener('transitionend', finish, { once: true });
    /* Red de seguridad por si transitionend no dispara. */
    window.setTimeout(finish, (this.config.duration || 4800) + 900);

    this.wheelEl.classList.add('is-spinning');
    void this.wheelEl.offsetWidth;
    this.wheelEl.style.transform = 'rotate(' + target + 'deg)';
  };

  Wheel.prototype.showResult = function (segment, restored) {
    var t = this.config.text;
    var isWin = !segment.losing && !!segment.code;

    if (this.resultHeading) {
      this.resultHeading.textContent = isWin ? t.winHeading : t.loseHeading;
    }
    if (this.resultText) {
      this.resultText.textContent = isWin
        ? String(t.winText || '').replace('[premio]', segment.label || '')
        : t.loseText;
    }
    if (this.codeRow) {
      this.codeRow.hidden = !isWin;
    }
    if (isWin && this.codeEl) {
      this.codeEl.value = segment.code;
    }
    if (this.cta) {
      this.cta.hidden = !isWin;
    }

    this.root.classList.add('is-done');
    this.dialog.classList.add('is-done');
    if (this.form) {
      this.form.hidden = true;
    }

    if (this.copyBtn && isWin) {
      this.copyBtn.focus();
    }

    if (!restored) {
      this.writeCartAttribute(segment);
    }

    this.root.dispatchEvent(
      new CustomEvent('psw:result', {
        bubbles: true,
        detail: { code: segment.code || '', label: segment.label || '', won: isWin }
      })
    );
  };

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-psw-root]');
    Array.prototype.forEach.call(nodes, function (root) {
      if (root.getAttribute('data-psw-ready') === '1') {
        return;
      }
      root.setAttribute('data-psw-ready', '1');
      new Wheel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Recarga dentro del personalizador de Shopify */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
